<template>
  <ul class="my-pop-setting-list">
    <li>
      <span class="alert-setting-tit">시청 예약 알림</span>
      <div class="radio-style">
        <span><input type="radio" class="radio-purple" id="ch-re-on" value="y" v-model="liveChecked" @change="changeStatus('live', 'y')"><label for="ch-re-on">ON</label></span>
        <span><input type="radio" class="radio-purple" id="ch-re-off" value="n" v-model="liveChecked" @change="changeStatus('live', 'n')"><label for="ch-re-off">OFF</label></span>
      </div>
    </li>
    <li>
      <span class="alert-setting-tit">구독 프로그램 업로드 알림</span>
      <div class="radio-style">
        <span><input type="radio" class="radio-purple" id="ch-up-on" value="y" v-model="uploadChecked" @change="changeStatus('upload', 'y')"><label for="ch-up-on">ON</label></span>
        <span><input type="radio" class="radio-purple" id="ch-up-off" value="n" v-model="uploadChecked" @change="changeStatus('upload', 'n')"><label for="ch-up-off">OFF</label></span>
      </div>
    </li>
  </ul>
</template>

<script>
import { postAlarmsReceiver, getAlarmsReceiver } from '@/common/utils/request'

export default {
  data () {
    return {
      liveChecked: '', // 시청 예약 알림
      uploadChecked: '' // 구독 프로그램 업로드 알림
    }
  },
  methods: {
    // 알림 상태 변경 API 호출
    changeStatus (type, value) {
      postAlarmsReceiver({
        live: type === 'live' ? value : 'd',
        upload: type === 'upload' ? value : 'd',
        movie: 'd',
        coupon: 'd',
        coin: 'd',
        event: 'd',
        myview: 'd',
        popular: 'd' })
    }
  },
  created () {
    getAlarmsReceiver().then((response) => {
      this.liveChecked = response.data.live === 'y' ? 'y' : 'n' // 시청 예약 알림
      this.uploadChecked = response.data.upload === 'y' ? 'y' : 'n' // 구독 프로그램 업로드 알림
    })
  }
}
</script>
